// extracted by mini-css-extract-plugin
export var card = "_ba-1";
export var container = "_ba-0";